// utils/getCircularCroppedBlob.ts
import { Area } from 'react-easy-crop'

export async function getCircularCroppedBlob(
  imageSrc: string,
  pixelCrop: Area
): Promise<Blob> {
  // 1) Load the source image
  const image = await new Promise<HTMLImageElement>((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload  = () => resolve(img)
    img.onerror = reject
    img.src     = imageSrc
  })

  // 2) Draw the cropped rectangle to a temp canvas
  const tmpCanvas = document.createElement('canvas')
  tmpCanvas.width  = pixelCrop.width
  tmpCanvas.height = pixelCrop.height
  const tmpCtx = tmpCanvas.getContext('2d')!
  tmpCtx.drawImage(
    image,
    pixelCrop.x, pixelCrop.y,
    pixelCrop.width, pixelCrop.height,
    0, 0,
    pixelCrop.width, pixelCrop.height
  )

  // 3) Create the final canvas & mask to a circle
  const size = Math.min(pixelCrop.width, pixelCrop.height)
  const canvas = document.createElement('canvas')
  canvas.width  = size
  canvas.height = size
  const ctx = canvas.getContext('2d')!

  // Draw the square crop (centered if your crop is rectangular)
  const dx = (size - pixelCrop.width)  / 2
  const dy = (size - pixelCrop.height) / 2
  ctx.drawImage(tmpCanvas, dx, dy)

  // Use destination-in to keep only the circle
  ctx.globalCompositeOperation = 'destination-in'
  ctx.beginPath()
  ctx.arc(size/2, size/2, size/2, 0, Math.PI * 2, true)
  ctx.closePath()
  ctx.fill()

  // 4) Export as a transparent PNG blob
  return await new Promise<Blob>((resolve) => {
    canvas.toBlob((blob) => resolve(blob!), 'image/png')
  })
}
